import * as t from "io-ts";

import {
    LocalStorageBackend,
    Repository,
    newPersistentObjContext,
} from "@thelabnyc/thelabui/src/hooks/persistent-state";

const LocaleModalState = t.type({
    loaded: t.boolean,
    dismissals: t.record(t.string, t.boolean),
});
type LocaleModalState = t.TypeOf<typeof LocaleModalState>;

const LOCALE_MODAL_KEY = "show-locale-modal";

const localeModalStateRepo = new Repository({
    backend: new LocalStorageBackend({
        codec: LocaleModalState,
        defaultVal: { loaded: false, dismissals: {} },
        storageKey: LOCALE_MODAL_KEY,
    }),
    writeLockName: LOCALE_MODAL_KEY,
    broadcastChannelName: LOCALE_MODAL_KEY,
});

const { Context: LocaleModalStateContext, Provider: LocaleModalStateProvider } =
    newPersistentObjContext({
        repo: localeModalStateRepo,
    });

export { LocaleModalStateContext, LocaleModalStateProvider };

export const getShowLocaleModalKey = (
    suggestedLocale: string,
    currentLocale: string,
): string => {
    return `${suggestedLocale}-from-${currentLocale}`;
};
